// @flow
// @ts-nocheck
import { handleActions } from 'redux-actions';
import { List, Map } from 'immutable';
// eslint-disable-next-line flowtype/no-weak-types
export var initialState = Map({
    data: List(),
    loading: false,
    loaded: false,
});
var reducer = handleActions({
    GET_STORES: function (state) { return state.set('loading', true); },
    GET_STORES_COMPLETE: {
        next: function (state, action) {
            return state
                .set('loading', false)
                .set('loaded', true)
                .set('data', action.payload);
        },
        throw: function (state) {
            return state.set('loading', false).set('loaded', false);
        },
    },
}, initialState);
export default reducer;
